<template>
    <v-card
      class="mx-auto"
      max-width="344"
      outlined
    >
      <template slot="progress">
        <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-list-item three-line>
        <v-list-item-content>
          <div class="mb-1">
            <v-row v-if="typeof  rate !== 'undefined'">
              <div class="grey--text">
                میانگین امتیاز : {{ rate }}/5
              </div>
              <v-spacer/>
              <v-rating
                :value="rate"
                color="warning"
                dense
                half-increments
                readonly
                size="24"
              ></v-rating>
            </v-row>
          </div>
          <v-list-item-title>
            <div>
            <span style="font-size: 12px">
            قیمت :
              {{ Intl.NumberFormat().format(parseInt(price)) }} ریال
            </span>
              <br/>
              <del style="color: #ff5154; font-size: 10px" v-if="typeof priceWithoutOff!=='undefined'">
                قیمت : {{ Intl.NumberFormat().format(parseInt(priceWithoutOff)) }} ریال
              </del>
              <div class="mt-4 text-subtitle-1">
                <v-chip color="error" v-if="typeof off!=='undefined'">{{ off }}% تخفیف</v-chip>
              </div>
            </div>
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-avatar
          tile
          size="50"
        >
          <v-img
            height="50"
            :src="getImage(image)"
          ></v-img>
        </v-list-item-avatar>
      </v-list-item>


      <v-card-text class="pt-0 mt-0">
        <v-row>
          <v-col style="font-size: 12px;">
            {{ title }}
          </v-col>
        </v-row>
        <v-row justify="center" style="height: 35px" v-if="typeof description!=='undefined'">
          <v-expansion-panels popout tile style="position: absolute ; z-index: 9999">
            <v-expansion-panel>
              <v-expansion-panel-header>اطلاعات بیشتر</v-expansion-panel-header>
              <v-expansion-panel-content>
                {{ description }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col>
            <v-btn
              tile
              color="success"
              width="100%"
              @click="runAction()"
            >
              <v-icon left>
                {{ mdiBasketOutline }}
              </v-icon>
              <template v-if="isAddToBasket">
                افزودن به سبد خرید
              </template>
              <template v-else>
                خرید
              </template>

            </v-btn>
          </v-col>
          <v-col v-if="hasCount">
            <v-text-field placeholder="تعداد" label="تعداد" outlined dense type="number"  v-model="number"
                          full-width></v-text-field>
          </v-col>
        </v-row>
      </v-card-actions>

    </v-card>
</template>


<script>
import {
  mdiBasketOutline
} from '@mdi/js'
import axios from "@axios";
import baseConfig from "@/../baseConfig";
import store from "@/store";
import router from "@/router";
import {getImage} from '@/../src/views/generator/page-handler'
export default {
  name: "product-template2",
  props: {
    id: Number,
    title: String,
    image: String,
    price: Number,
    priceWithoutOff: Number,
    number: Number,
    off: Number,
    rate: Number,
    description: String,
    action: String,
    isAddToBasket: Boolean,
    hasCount: Boolean,
  },
  data() {
    return {
      mdiBasketOutline: mdiBasketOutline,
      getImage: getImage,
    }
  },
  methods: {
    async runAction() {
      const body = new FormData()
      body.append('productId', this.id)
      body.append('isAddToBasket', this.isAddToBasket)
      body.append('productPrice', this.price)
      body.append('productPriceWithoutOff', this.priceWithoutOff)
      body.append('productOff', this.off)
      body.append('title', this.title)
      let objectForDialog = []
      objectForDialog.push({
        name: "productId",
        model: this.id
      })
      objectForDialog.push({
        name: "isAddToBasket",
        model: this.isAddToBasket
      })
      objectForDialog.push({
        name: "productPrice",
        model: this.price
      })
      objectForDialog.push({
        name: "productPriceWithoutOff",
        model: this.priceWithoutOff
      })
      objectForDialog.push({
        name: "productOff",
        model: this.off
      })
      objectForDialog.push({
        name: "count",
        model: this.number
      })

      await axios.post(`${baseConfig.baseUrl + this.action}`, body).then(async r => {
        if (typeof r.data.dialog !== 'undefined')
          this.$emit('open-dialog', r.data.dialog, objectForDialog, r.data.dialog+"Form", r)
        else{
          let response = {
            data: {
              message: r.data.message,
              status: r.data.status
            }
          }
          if (typeof r.data.redirect !== 'undefined') {
            if (r.data.redirect !== '') {
              store.dispatch('message/setMessage', response).then(() => {

              })
              let result = r.data.redirect.includes("http");
              if (result) {
                window.location.href = r.data.redirect
              } else {
                await router.push(`/${r.data.redirect}`)
              }
            } else {
              this.$emit('response_handler', response, true)
            }
          }
        }

      })
    },
    onPagination(name, current) {
      console.log('on product template',name, current)
      this.$emit('on-pagination', name, current, this.filter)
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.v-list-item__title, .v-list-item__subtitle {
  white-space: normal !important;
}
</style>
